import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss']
})
export class InfoIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
